import api from '../../utils/api';

export const VEHICLE_FETCHED = 'VEHICLE_FETCHED';

export function fetchVehicleById(id) {
  return async function(dispatch) {
    try {
      const { vehicle } = await api.vehicles.getOne(id);

      dispatch({
        type: VEHICLE_FETCHED,
        vehicle
      });

      return vehicle;
    } catch (error) {
      throw error;
    }
  };
}
